( function () {
	'use strict';

	function init( wrap ) {
		if ( wrap.getAttribute( 'data-kz-ready' ) ) {
			return;
		}
		wrap.setAttribute( 'data-kz-ready', '1' );
		var list = wrap.querySelector( '.kz-cc__list' );
		var prev = wrap.querySelector( '.kz-cc__arrow--prev' );
		var next = wrap.querySelector( '.kz-cc__arrow--next' );
		if ( ! list ) {
			return;
		}

		function update() {
			var max = list.scrollWidth - list.clientWidth;
			var overflow = max > 2;
			wrap.classList.toggle( 'is-overflowing', overflow );
			if ( prev ) { prev.hidden = ! overflow || list.scrollLeft <= 2; }
			if ( next ) { next.hidden = ! overflow || list.scrollLeft >= max - 2; }
		}

		wrap.addEventListener( 'click', function ( e ) {
			var btn = e.target.closest( '.kz-cc__arrow' );
			if ( ! btn ) {
				return;
			}
			list.scrollBy( { left: parseInt( btn.getAttribute( 'data-dir' ), 10 ) * list.clientWidth * 0.8, behavior: 'smooth' } );
		} );
		list.addEventListener( 'scroll', update, { passive: true } );
		window.addEventListener( 'resize', update );
		update();
	}

	function boot() {
		Array.prototype.forEach.call( document.querySelectorAll( '[data-kz-cc]' ), init );
	}
	document.addEventListener( 'shopify:section:load', boot );
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', boot );
	} else {
		boot();
	}
} )();
